module.exports = __webpack_public_path__ + "media/application/images/2018/bookmark-icons-5710fbce98e50095c6267cb721f5a2ce.png";